// @flow

import React, { useState } from 'react';
import randomId from 'javascripts/utils/random-id';
import classNames from 'classnames';
import Icon from 'components/_particles/icon/react/Icon';

export type Props = {
  id?: string,
  name?: string,
  value?: string,
  checked?: boolean,
  required?: boolean,
  disabled?: boolean,
  invalid?: boolean,
  descriptionId?: string,
  labelId?: string,
  errorId?: string,
  label?: string,
  onChange?: (event: SyntheticInputEvent<HTMLInputElement>) => void,
  className?: string,
  checked?: boolean,
};

const Checkbox = ({
  id,
  name,
  value,
  checked: initialChecked,
  required,
  disabled,
  invalid,
  descriptionId,
  labelId,
  errorId,
  label,
  onChange,
  className,
  checked,
}: Props): React$MixedElement => {
  const baseId = id || `checkbox-${randomId()}`;

  const handleChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    onChange?.(event);
  };

  return (
    <label htmlFor={baseId} className={classNames('checkbox', className)}>
      <input
        id={baseId}
        type="checkbox"
        name={name}
        checked={checked}
        required={required}
        disabled={disabled}
        aria-invalid={invalid ? 'true' : undefined}
        aria-describedby={descriptionId}
        aria-labelledby={labelId}
        aria-errormessage={errorId}
        onChange={handleChange}
        className="checkbox__input"
      />
      <span className="checkbox__indicator">
        <Icon icon="check" className="checkbox__indicator-icon" />
      </span>
      <span className="checkbox__label">{label}</span>
    </label>
  );
};

export default Checkbox;
